export default __webpack_public_path__ + "static/media/gear.940fb640.svg";